import { Configuration, ItemsApi } from "../../generated-client";
import "reflect-metadata";

export class ItemsClient {
	public itemsApi: ItemsApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
			accessToken: () => sessionStorage.getItem("jwt") || "",
		});
		this.itemsApi = new ItemsApi(config);
	}
}
